import { createSlice } from '@reduxjs/toolkit'
import { coreState } from './core-state'
import { closeTab, handleMenuItemClick, loadContent } from './controller'

const coreReducer = createSlice({
  name: 'core',
  initialState: coreState(),
  reducers: {
    resetState: (state) => {
      state = coreState()
    },
    addTab: (state, action) => {
      state.tabNavigation.lastActiveKey.push(state.tabNavigation.activeKey)
      loadContent(action.payload, state)
    },
    menuItemClick: (state, action, popped) => {
      // Menu item click is used to load the content of the tab
      if (state.tabNavigation.activeKey === action.payload.key) {
        // Added so that if the same menu being clicked it wont keep adding bread crumbs
        return
      }
      // this allows the back button to be used in the menu to navigate backwards to previous tabs.
      if (!action.payload.popped) {
        state.tabNavigation.lastActiveKey.push(state.tabNavigation.activeKey)
      } else {
        state.tabNavigation.lastActiveKey.splice(state.tabNavigation.lastActiveKey.length - 1, 1)
      }
      loadContent(handleMenuItemClick(action.payload, state.tabNavigation.activeKey), state)
    },
    changeTab: (state, action) => {
      state.tabNavigation.lastActiveKey.push(state.tabNavigation.activeKey)
      state.tabNavigation.activeKey = action.payload
    },
    closeTab: (state, action) => {
      closeTab(state, action.payload)
    },
    enableDisableToolbar: (state, action) => {
      state.toolbar.enabled = action.payload
    },
    enableDisableTabs: (state, action) => {
      state.tabNavigation.enabled = action.payload
    },
    hideTabs: (state, action) => {
      state.tabNavigation.hidden = action.payload
    },
    enableDisableLeftMenu: (state, action) => {
      state.leftMenu.leftMenuEnabled = action.payload
    },
    enableDisableRightMenu: (state, action) => {
      state.rightMenu.rightMenuEnabled = action.payload
    },
    leftMenuOpenClose: (state) => {
      state.leftMenu.visible = !state.leftMenu.visible
    },
    rightMenuOpenClose: (state) => {
      state.rightMenu.visible = !state.rightMenu.visible
    },
    setSideBarExpanded: (state, action) => {
      state.sideBarExpanded = action.payload !== undefined ? action.payload : !state.sideBarExpanded
    },
    setRootContent: (state, action) => {
      state.rootContent = action.payload
    },
    setBreadcrumbs: (state, action) => {
      state.breadcrumbs = action.payload
    },
    setEntity: (state, action) => {
      state.entity = action.payload
    },
    setNoEntityFound: (state, action) => {
      state.noEntityFound = action.payload
    },
    setAppTitle: (state, action) => {
      state.title = action.payload
    },
    openTour: (state, action) => {
      state.tourOpen = true
    },
    closeTour: (state) => {
      state.tourOpen = false
    },
    nextTourStep: (state) => {
      state.tourStep = state.tourStep + 1
    },
    previousTourStep: (state) => {
      state.tourStep = state.tourStep - 1
    },
    resetTourStep: (state) => {
      state.tourStep = 0
    },
    setHiddenLeftMenuItems: (state, action) => {
      state.hiddenLeftMenuItems = action.payload
    },
    setSignOutDisabled: (state, action) => {
      state.signOutDisabled = action.payload
    },
    setMobNavBarEnabled: (state, action) => {
      state.mobNavBarEnabled = action.payload
    },
    setOnline: (state, action) => {
      state.online = action.payload
    },
    setUnsavedChanges: (state, action) => {
      state.unsavedChanges = action.payload
    }
  }
})

export default coreReducer
